<div class="ship-log">
  <p class="lede">The week compressed itself into thirty-six hours. Between Wednesday evening and Thursday morning, <strong>30 changes</strong> merged across the app and the site. Competitions got a memory, duels got live updates, freeze days got an undo button. Then, for the first time in weeks: three deliberately quiet days.</p>

  <div class="tiles">
    <div class="tile"><div class="num">4</div><div class="lbl">days covered (Jul 23&ndash;26)</div></div>
    <div class="tile"><div class="num">30</div><div class="lbl">changes merged</div></div>
    <div class="tile"><div class="num">1</div><div class="lbl">production deploy</div></div>
    <div class="tile"><div class="num">24</div><div class="lbl">backlog items cleared</div></div>
  </div>

  <h2>Sprint map</h2>
  <p class="h2-sub">One row per story arc, one column per day. &dagger; marks late-evening work from July 22 that belongs to this week's story.</p>
  <div class="legend">
    <span><span class="dot dot-product"></span> Product</span>
    <span><span class="dot dot-reliability"></span> Reliability</span>
    <span><span class="dot dot-infra"></span> Under the hood</span>
  </div>
  <div class="gantt">
    <table>
      <tr><th class="rowlab"></th><th>Jul 22&dagger;</th><th>Jul 23</th><th>Jul 24</th><th>Jul 25</th><th>Jul 26</th></tr>
      <tr><td class="rowlab">Weekly habits: instant badge</td><td><div class="cell on-product"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td></tr>
      <tr><td class="rowlab">Rest &amp; freeze days</td><td><div class="cell on-product"></div></td><td><div class="cell on-product"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td></tr>
      <tr><td class="rowlab">Competitions: history + top ten</td><td><div class="cell on-product"></div></td><td><div class="cell on-product"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td></tr>
      <tr><td class="rowlab">Duels: live updates</td><td><div class="cell on-product"></div></td><td><div class="cell on-product"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td></tr>
      <tr><td class="rowlab">Connect &amp; account flows</td><td><div class="cell on-product"></div></td><td><div class="cell on-product"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td></tr>
      <tr><td class="rowlab">Sync reliability</td><td><div class="cell on-reliability"></div></td><td><div class="cell on-reliability"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td></tr>
      <tr><td class="rowlab">Internal tooling &amp; tests</td><td><div class="cell on-infra"></div></td><td><div class="cell on-infra"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td></tr>
      <tr><td class="rowlab">Docs &amp; release</td><td><div class="cell on-infra"></div></td><td><div class="cell on-infra"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td><td><div class="cell"></div></td></tr>
    </table>
  </div>
  <p class="gantt-note">Jul 24&ndash;26: no merges at all. The wave was done; the quiet days are real.</p>

  <h2>Merges per day</h2>
  <div class="bars">
    <div class="row">
      <div class="col"><div class="val">17</div><div class="bar" style="height:100%"></div><div class="day">Jul 22&dagger;</div></div>
      <div class="col"><div class="val">13</div><div class="bar" style="height:76%"></div><div class="day">Jul 23</div></div>
      <div class="col"><div class="val">0</div><div class="bar zero"></div><div class="day">Jul 24</div></div>
      <div class="col"><div class="val">0</div><div class="bar zero"></div><div class="day">Jul 25</div></div>
      <div class="col"><div class="val">0</div><div class="bar zero"></div><div class="day">Jul 26</div></div>
    </div>
  </div>

  <h2>The arcs</h2>
  <p class="h2-sub">In rough chronological order. &dagger; marks the July 22 evening batch.</p>

  <div class="arc">
    <div class="tags"><span class="tag product">Product</span></div>
    <h3>Weekly habits: instant badge &dagger;</h3>
    <p>Times-per-week habits now light up their badge the moment the weekly quota lands, with a preview state on the way there. Switching a habit to a weekly schedule now seeds the streak correctly, so the badge is honest from day one.</p>
  </div>

  <div class="arc">
    <div class="tags"><span class="tag product">Product</span></div>
    <h3>Rest &amp; freeze days: undo + fairer math</h3>
    <p>Two halves of the same fairness story. A tavern day no longer drags down your completion rate, because daily habits settle no due units on frozen days. An accidental tavern visit is now reversible until midnight with the new same-day undo, straight from the widget.</p>
  </div>

  <div class="arc">
    <div class="tags"><span class="tag product">Product</span></div>
    <h3>Competitions: history + top-ten leaderboards</h3>
    <p>Finished competitions stop vanishing. The competitions tab now keeps a browsable history of past rounds. Leaderboards show the top ten with a Show-all toggle, which keeps large competitions fast and readable.</p>
  </div>

  <div class="arc">
    <div class="tags"><span class="tag product">Product</span></div>
    <h3>Duels: live + honest</h3>
    <p>Duel notifications surface what changed since you last looked, with live updates while a duel is active. An opponent whose sync is paused is now marked in the head-to-head, so a frozen score explains itself.</p>
  </div>

  <div class="arc">
    <div class="tags"><span class="tag product">Product</span></div>
    <h3>Connect &amp; account flows</h3>
    <p>Five small cuts, one smoother path. The post-connect success card now leads with your widget link. A failed widget-link fetch shows an error with a retry. Password reset clears stale sessions and confirms cleanly. A rendering glitch around the Upgrade button on the profile page is gone. The widget took a first pass at small-phone layouts; the embed inside Notion's mobile app still needs polish, so more is on the way there.</p>
  </div>

  <div class="arc">
    <div class="tags"><span class="tag reliability">Reliability</span></div>
    <h3>Sync reliability</h3>
    <p>The nightly sync engine got more careful. Schedule switches now reset streak counts to the matching unit, so longest-streak stats stay honest. The safety net that catches missed syncs selects its work more precisely and no longer cries wolf.</p>
  </div>

  <div class="arc">
    <div class="tags"><span class="tag infra">Under the hood</span></div>
    <h3>Internal tooling &amp; tests</h3>
    <p>A long-planned refactoring batch paid down debt in the mail and competition code. New tests cover feature access and habit comparison. The end-to-end suite gained a second seeded user, which unlocks full duel testing. Newsletter sending and feedback review got quicker internal tools.</p>
  </div>

  <div class="arc">
    <div class="tags"><span class="tag infra">Under the hood</span></div>
    <h3>Docs &amp; release</h3>
    <p>A documentation sweep corrected eight drifted passages. The release train carried the whole wave to production the morning after.</p>
  </div>

  <p class="prov">Compiled from the week's merge history across the Notion Habit Heroes app and this site, July 23&ndash;26, 2026, plus the late evening of July 22. The quiet days are genuine: no merges landed July 24&ndash;26.</p>
</div>
